/** Visible time window for the disposition calendar (local hours). */
export const CALENDAR_DAY_START_HOUR = 8
export const CALENDAR_DAY_END_HOUR = 18
export const CALENDAR_HOURS_IN_RANGE = CALENDAR_DAY_END_HOUR - CALENDAR_DAY_START_HOUR
export const CALENDAR_DAY_DURATION_MINUTES = CALENDAR_HOURS_IN_RANGE * 60
